// Case- and whitespace-tolerant substring matching, shared by two callers that
// must behave identically: library title search (FR-021) and the insert-field
// filter (FR-028). One definition of "matches what the user typed" means the two
// cannot drift apart on a later Unicode or trimming fix — a divergence users
// would report as inconsistency (research.md D-15).

/**
 * True when `needle` appears in `haystack`, ignoring case and surrounding
 * whitespace on the needle. An empty or whitespace-only needle matches
 * everything — which is what restores the full list when a filter box is cleared.
 */
export function containsFold(haystack: string, needle: string): boolean {
  const trimmed = needle.trim().toLocaleLowerCase();
  if (trimmed.length === 0) return true;
  return haystack.toLocaleLowerCase().includes(trimmed);
}

// Title search runs entirely in the browser over the already-loaded list
// (FR-021, research.md D-06). The whole searchable corpus is tens of titles that
// the library view already fetched, so a server round-trip — let alone a search
// service — would be machinery for a problem this project does not have.
export function matchesTitleSearch(title: string, query: string): boolean {
  return containsFold(title, query);
}
